var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreBenefitsEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 30C3.16699 30 13.167 10 30.667 10C48.167 10 58.167 30 58.167 30C58.167 30 48.167 50 30.667 50C13.167 50 3.16699 30 3.16699 30Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 37.5C34.8091 37.5 38.167 34.1421 38.167 30C38.167 25.8579 34.8091 22.5 30.667 22.5C26.5249 22.5 23.167 25.8579 23.167 30C23.167 34.1421 26.5249 37.5 30.667 37.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsEye);
export default __webpack_public_path__ + "static/media/core-benefits-eye.123348a61644e46f2be2429667668848.svg";
export { ForwardRef as ReactComponent };